import React, { useContext } from 'react'
import { motion } from 'framer-motion/dist/framer-motion'
import parse, { domToReact } from 'html-react-parser'

import { UIContext } from '../../../Context/UIContext'

import usePreloadImage from '../../../usePreloadImage'

import './About.scss'

import Section from '../../Section'

const options = {
    replace: ({ attribs, children }) => {
        if (!attribs) return;

        const tagNames = ['h1', 'h2', 'h3', 'p', 'ul'];
        const tagName = attribs.tagName;

        if (tagNames.includes(tagName)) {
            if (tagName === 'ul') {
                return (
                    <ul>
                        {children.map((child, i) => 
                            <li key={`sub-item-${i}`}>
                                {domToReact(child.children, options)}
                            </li>
                        )}
                    </ul>
                );
            } else {
                return React.createElement(tagName, {}, domToReact(children, options));
            }
        }
    }
}

const About = ({ data }) => {
    const { title, content } = data

    const { isMobile } = useContext(UIContext)
    const imageLoaded = usePreloadImage(isMobile ? content.mobile : content.image)

    return (
        <Section
            name="mga-about"
            className="mga-about-section"
            motionProps={{
                initial: false,
                animate: { opacity: 1 },
                exit: { opacity: 0, transition: { duration: 0.5 }},
                transition: { duration: 0.3 }
            }}
        >
            <motion.div
                className="mga-about-section__top"
            >
                <motion.div className="mga-section__wrapper">
                    <motion.h1
                        initial={{ opacity: 0, y: '-200%' }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1 }}
                    >
                        { title }
                    </motion.h1>
                    <motion.div
                        initial={{ opacity: 0, y: '20%' }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, delay: 0.5 }}
                    >
                        {parse(content.info, options)}
                    </motion.div>
                </motion.div>
            </motion.div>
            <motion.div
                className="mga-about-section__bottom"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1, delay: 1 }}
            >
                { imageLoaded && <img src={isMobile ? content.mobile : content.image} alt={title} /> }
            </motion.div>
        </Section>
    )
}

export default React.memo(About)
